var fwslName = 'fw-slider',
    _fwsls = document.getElementsByClassName(fwslName),
    cssAnimationSupported = cssAnimationSupported || {},
    transitionEvent = whichTransitionEvent(),
    jsInitClass = fwslName + '--js-inited',
    animationClass = 'is-animated',
    customNavClass = fwslName + '__custom-nav',
    customNavBtnActiveClass = 'fwsl--active',
    arrowBtnClass = fwslName + '__arrow',
    navClass = fwslName + '__inner-nav',
    dotNavClass = fwslName + '__dot-nav',
    dotBtnClass = fwslName + '__dot-btn',
    dotBtnsActiveClass = dotBtnClass + '--active',
    cloneClass = fwslName + '__clone',
    threshold = 50,
    slideCommonDelay = 4000,
    slideFirstDelay = slideCommonDelay,
    allSliders = {};

module.exports = function(name, container) {
  if (!allSliders[name]) allSliders[name] = new FWSlider(container, name);
  return allSliders[name];
}

function FWSlider(_slider, name) {

  _slider.dataset.sliderName = name;

  this.el = {
    slider: _slider,
    holder: _slider.querySelector('.' + fwslName + '__slides'),
    slides: _slider.querySelectorAll('.' + fwslName + '__slides > *'),
    customNav: document.querySelectorAll('.' + customNavClass + '[data-for=' + _slider.id + ']')
  };

  this._actions = {};

  this.slideWidth =  _slider.offsetWidth;
  this.initialLength =  _slider.querySelectorAll('.' + fwslName + '__slides > *').length;
  this.touchstartx = 0;
  this.touchmovex = 0;
  this.movex = 0;
  this.distancemoved = 0;
  this.index = 0;
  this.TO_autoplay = undefined;
  this.autoplay = !!(_slider.dataset.autoplay && _slider.dataset.autoplay !== 'false');
  this.arrowNav = !!(_slider.dataset.arrowNav && _slider.dataset.arrowNav !== 'false');
  this.dotNav = !!(_slider.dataset.dotNav && _slider.dataset.dotNav !== 'false');
  this.handles = {};
  this.inited = false;


  if (this.el.slides.length > 1) {
    this.init();
  } else {
    this.el.slides[0].querySelectorAll('.js-img-lazy').forEach(function(img) {
      cube.lazyload.display(img);
    });
  }
};

FWSlider.prototype.destroy = function() {
  this.unbindSwipes();
  this.el.holder.removeAttribute('style');
  this.el.holder.removeEventListener(transitionEvent, this.handles.animateAndCallback);
  this.el.holder.removeEventListener("click", _this.preventClickAfterSwipe);

  var name = this.el.slider.dataset.sliderName;

  delete allSliders[name]
};

FWSlider.prototype.on = function(action, _function) {
  if (!this._actions[action]) this._actions[action] = [];

  // If _function doesn't exists : push it to action's array
  if (this._actions[action].indexOf(_function) === -1)
    this._actions[action].push(_function);
};

// INIT
FWSlider.prototype.init = function() {

  var _this = this,

      // create clones of first 2 and last 2 elements
      firstItemClone = _this.el.slides[0].cloneNode(true),
      secondItemClone = _this.el.slides[1].cloneNode(true),
      lastItemClone = _this.el.slides[_this.initialLength - 1].cloneNode(true),
      penultimateItemClone = _this.el.slides[_this.initialLength - 2].cloneNode(true),
      clones = [firstItemClone, secondItemClone, lastItemClone, penultimateItemClone];

  // Remove id from clones and add suffix to their ided children
  clones.forEach(function(clone) {
    var idedElements = clone.querySelectorAll('[id]');
    clone.removeAttribute('id');
    clone.classList.add(cloneClass);
    idedElements.forEach(function(el) {
      el.id = el.id + '--clone';
    });
  });

  // append clones to the slider
  _this.el.holder.insertBefore(penultimateItemClone, _this.el.slides[0]);
  _this.el.holder.insertBefore(lastItemClone, _this.el.slides[0]);
  _this.el.holder.appendChild(firstItemClone);
  _this.el.holder.appendChild(secondItemClone);

  _this.el.slidesWithClones = _this.el.slider.querySelectorAll('.' + fwslName + '__slides > *');

  if(_this.dotNav) {
    _this.buildDotNav();
  }
  if(_this.arrowNav) {
    _this.buildArrowNav();
  }

  if(_this.el.customNav.length) {
    // Build an array with every external nav elements
    _this.el.customNavEls = [];
    [].forEach.call(_this.el.customNav, function(_nav) {
      var _navElements = _nav.querySelectorAll('[href]');
      [].forEach.call(_navElements, function(_navEl) {
        _this.el.customNavEls.push(_navEl);
      });
    });
  };

  // Prevent drag events
  [].forEach.call(_this.el.slides, function(_slide) {
    _slide.addEventListener('dragstart', function(e) {  e.preventDefault(); });
    _slide.addEventListener('dragend', function(e) {    e.preventDefault(); });
    _slide.addEventListener('dragleave', function(e) {  e.preventDefault(); });
  });

  //the index is inited at 2, because, 2 extra images are added to the collection : a clone of the last image is added at start,
  // and a clone of the first image is added at the end
  _this.index = 2;

  _this.lazyLoadImages(_this.index);

  _this.el.holder.style.transform = 'translate3d(-' + _this.index * 100 + '%,0,0)';

  _this.inited = true;
  _this.el.slider.classList.add(jsInitClass);

  _this.bindSwipes();
  _this.bindClicks();
  _this.updateNavHighlights();

  if(_this.autoplay)
    _this.startAutoPlay(slideFirstDelay);
};

FWSlider.prototype.stopAutoPlay = function() {
  var _this = this;
  clearTimeout(_this.TO_autoplay);
};
FWSlider.prototype.startAutoPlay = function(delay) {
  var _this = this,
      actualdelay = slideCommonDelay;

  if (delay)
    actualdelay = delay;

  _this.TO_autoplay = setTimeout( function() {
    _this.goto('next', true);
  }, actualdelay);
};

// Build a nav element to contain arrow and/or dot nav
FWSlider.prototype.buildNavContainer = function() {
  var _this = this,
      navContainer = document.createElement('nav');

  navContainer.setAttribute('class', navClass);
  _this.el.slider.appendChild(navContainer);
  _this.el.navContainer = _this.el.slider.querySelector('.' + navClass);
};
FWSlider.prototype.buildDotNav = function() {
  var _this = this,
      newDot,
      newDotSpan,
      newDotSpanText;

  if(!_this.el.navContainer) {
    _this.buildNavContainer();
  }

  for (var u = 1; u <= _this.initialLength; u++) {
    newDot = document.createElement('button');
    newDotSpan = document.createElement('span');
    newDotSpanText = document.createTextNode(Messages('fullwidthslider.reach') + u);

    newDotSpan.setAttribute('class', 'vh');
    newDot.setAttribute('class', dotBtnClass);

    newDotSpan.appendChild(newDotSpanText);
    newDot.appendChild(newDotSpan);
    _this.el.navContainer.appendChild(newDot);
  }
};

FWSlider.prototype.buildArrowNav = function() {
  var _this = this,
      btnNav = document.createElement('button'),
      innerSpan = document.createElement('span'),
      innerSpanTextPrev = document.createTextNode(Messages('fullwidthslider.previous')),
      innerSpanTextNext = document.createTextNode(Messages('fullwidthslider.next')),
      prevBtn,
      nextBtn;

  if(!_this.el.navContainer) {
    _this.buildNavContainer();
  }

  innerSpan.setAttribute('class', 'vh');
  btnNav.appendChild(innerSpan);
  prevBtn = btnNav.cloneNode(true);
  nextBtn = btnNav.cloneNode(true);

  prevBtn.setAttribute('class', arrowBtnClass + ' ' + arrowBtnClass + '--prev');
  nextBtn.setAttribute('class', arrowBtnClass + ' ' + arrowBtnClass + '--next');
  prevBtn.getElementsByClassName('vh')[0].appendChild(innerSpanTextPrev);
  nextBtn.getElementsByClassName('vh')[0].appendChild(innerSpanTextNext);

  _this.el.navContainer.insertBefore(prevBtn, _this.el.navContainer.childNodes[0]);
  _this.el.navContainer.appendChild(nextBtn);
};

FWSlider.prototype.updateNavHighlights = function() {
  var _this = this;

  // Update active dot display
  if(_this.dotNav) {
    var dotBtns = document.getElementsByClassName(dotBtnClass);
    [].forEach.call(dotBtns, function(_dot, index) {
      if ((index === _this.index - 2) || (_this.index === _this.initialLength + 2 && index === 0) || (_this.index === 1 && index === dotBtns.length - 1)) {
        _dot.classList.add(dotBtnsActiveClass);
      } else {
        _dot.classList.remove(dotBtnsActiveClass);
      }
    });
  }

  // Update active custom nav element display
  if (_this.el.customNav.length) {
    var targetIndex = _this.index - 2,
    indexId;

    if (_this.index === _this.initialLength + 2) {
      targetIndex = 0;
    }
    if (_this.index === 1) {
      targetIndex = _this.initialLength - 1;
    }

    indexId = _this.el.slides[targetIndex].getAttribute('id');

    [].forEach.call(_this.el.customNavEls, function(_navEl) {
      if (_navEl.getAttribute('href') !== '#' + indexId) {
        _navEl.classList.remove(customNavBtnActiveClass);
      } else {

        if (_navEl.closest('.' + customNavClass)) {
          // Update class
          _navEl.classList.add(customNavBtnActiveClass);


          // Scroll to position if it's outside viewport
          var _parent = _navEl.closest('.' + customNavClass),
              _parent_rect = _parent.getBoundingClientRect(),
              _navEl_rect = _navEl.getBoundingClientRect();

          if(
            (_navEl_rect.left < _parent_rect.left) ||
            (_navEl_rect.left + _navEl_rect.width > _parent_rect.left + _parent_rect.width) ||
            (_navEl_rect.top < _parent_rect.top) ||
            (_navEl_rect.top + _navEl_rect.height > _parent_rect.top + _parent_rect.height)
            ) {
            $(_navEl.closest('.' + customNavClass)).scrollTo($(_navEl), 200 )
          }
        }

      }
    });
  }
};

// Load images from actual slide, next slide, and previous slide
FWSlider.prototype.lazyLoadImages = function(index) {
  var _this = this,
      // Actual slide / next slide / previous slide
      slideSet = [_this.el.slidesWithClones[index], _this.el.slidesWithClones[index + 1], _this.el.slidesWithClones[index - 1]];

  if (index === 2) {
    slideSet.push(_this.el.slidesWithClones[_this.el.slidesWithClones.length - 3]);
  }
  if (index === _this.el.slidesWithClones.length - 3) {
    slideSet.push(_this.el.slidesWithClones[2]);
  }

  slideSet.forEach(function(slide) {
    slide.querySelectorAll('.js-img-lazy, .js-picture-lazy').forEach(cube.lazyload.display);
  });

};


FWSlider.prototype.handlePointerDown = function(event) { this.down(event); };
FWSlider.prototype.down = function(event) {
  var _this = this,
      eventTouches = event.touches ? event.touches.length : 1,
      entryPointsNumber = event.buttons || eventTouches;

  // only act 'down' status if there's no more than 1 entry point
  if (entryPointsNumber === 1) {

    if(_this.autoplay) {
      _this.stopAutoPlay();
    }

    // update slidewidth status (used for move calculations)
    _this.slideWidth= _this.el.slider.offsetWidth;

    if (event.type === 'touchstart') {
      _this.touchstartx = event.originalEvent ? event.originalEvent.touches[0].pageX : event.touches[0].pageX;
    } else if (event.type === 'mousedown') {
      _this.touchstartx = event.pageX;
    }


    _this.handles.handlePointerMove = _this.handlePointerMove.bind(_this);
    _this.handles.handlePointerRelease = _this.handlePointerRelease.bind(_this);

    _this.el.holder.addEventListener("touchmove", _this.handles.handlePointerMove);
    _this.el.holder.addEventListener("mousemove", _this.handles.handlePointerMove);
    _this.el.holder.addEventListener("touchend", _this.handles.handlePointerRelease);
    _this.el.holder.addEventListener("mouseup", _this.handles.handlePointerRelease);
    _this.el.holder.addEventListener("mouseleave", _this.handles.handlePointerRelease);
    _this.el.holder.addEventListener("contextmenu", _this.handles.handlePointerRelease);
  } else {
    _this.release(event);
  }
};


FWSlider.prototype.preventClickAfterSwipe = function(event) {
  event.preventDefault();
  event.stopPropagation();
};

FWSlider.prototype.handlePointerMove = function(event) { this.move(event); };
FWSlider.prototype.move = function(event) {
  var _this = this;

  if (event.type === 'touchmove') {
    _this.touchmovex = event.originalEvent ? event.originalEvent.touches[0].pageX : event.touches[0].pageX;
  } else if (event.type === 'mousemove') {
    _this.touchmovex = event.pageX;
  }

  // Translate distance calculation
  _this.distancemoved = _this.touchstartx - _this.touchmovex;
  _this.movex = _this.index * _this.slideWidth + _this.distancemoved;


  // Block scroll during swipe
  if (_this.distancemoved > 8  || _this.distancemoved < -8) {
    event.preventDefault();
  }

  _this.el.holder.style.transform = 'translate3d(-' + _this.movex + 'px,0,0)';
};

FWSlider.prototype.handlePointerRelease = function(event) { this.release(event); };
FWSlider.prototype.release = function(event) {
  var _this = this;

  // prevent click after swipe
  if (_this.distancemoved > 2  || _this.distancemoved < -2) {
    _this.el.holder.addEventListener("click", _this.preventClickAfterSwipe);
  }

  // either you stay where you are, or you go forward / backward.
  if ((_this.distancemoved > threshold) || (_this.distancemoved < threshold * -1)) {

    if (_this.movex > _this.index * _this.slideWidth) {
      _this.goto('next');
    } else if (_this.movex < _this.index * _this.slideWidth) {
      _this.goto('prev');
    } else _this.unbindSwipes()
  } else {
    _this.goto('stay');
  }
};


FWSlider.prototype.bindClicks = function() {
      var _this = this;

      var gotoByClick = function(e, target) {
        e.preventDefault();
        e.stopImmediatePropagation();
        cube.event.send('fwSlider_thumbnailClicked', target);
        if (!_this.el.holder.classList.contains(animationClass)) {
          _this.goto(target);
        }
      };

  if(_this.arrowNav) {
    var prevBtns = document.getElementsByClassName(arrowBtnClass + '--prev'),
        nextBtns = document.getElementsByClassName(arrowBtnClass + '--next');

    [].forEach.call(prevBtns, function(_prevBtn) {
      _prevBtn.addEventListener("click", function(e) {
        gotoByClick(e, 'prev');
      });
    });

    [].forEach.call(nextBtns, function(_nextBtn) {
      _nextBtn.addEventListener("click", function(e) {
        gotoByClick(e, 'next');
      });
    });
  }

  if(_this.dotNav) {
    var dotBtns = document.getElementsByClassName(dotBtnClass);

    [].forEach.call(dotBtns, function(_dot, index) {
      _dot.addEventListener("click", function(e) {
        if(!_dot.classList.contains(dotBtnsActiveClass)) {
          gotoByClick(e, index);
        }
      });
    });
  }

  if(_this.el.customNavEls && _this.el.customNavEls.length) {
    [].forEach.call(_this.el.customNavEls, function(_navEl) {
      var targetId = _navEl.getAttribute('href').replace('#', '');
      var targetEl = document.getElementById(targetId);
      var targetIndex = [].indexOf.call(_this.el.slides, targetEl);

      _navEl.addEventListener("click", function(e) {
        if(!_navEl.classList.contains(customNavBtnActiveClass)) {
          gotoByClick(e, targetIndex);
        } else {
          e.preventDefault();
        }
      });

    });
  }


};
FWSlider.prototype.bindSwipes = function() {
  var _this = this;

  _this.handles.handlePointerDown = _this.handlePointerDown.bind(_this);

  _this.el.holder.addEventListener("touchstart", _this.handles.handlePointerDown);
  _this.el.holder.addEventListener("mousedown", _this.handles.handlePointerDown);
};
FWSlider.prototype.unbindSwipes = function() {
  var _this = this;

  if (_this.handles.handlePointerDown) {
    _this.el.holder.removeEventListener("touchstart", _this.handles.handlePointerDown);
    _this.el.holder.removeEventListener("mousedown", _this.handles.handlePointerDown);
    delete _this.handles.handlePointerDown;
  }


  if (_this.handles.handlePointerMove) {
    _this.el.holder.removeEventListener("touchmove", _this.handles.handlePointerMove);
    _this.el.holder.removeEventListener("mousemove", _this.handles.handlePointerMove);
    delete _this.handles.handlePointerMove;
  }

  if (_this.handles.handlePointerRelease) {
    _this.el.holder.removeEventListener("touchend", _this.handles.handlePointerRelease);
    _this.el.holder.removeEventListener("mouseup", _this.handles.handlePointerRelease);
    _this.el.holder.removeEventListener("mouseleave", _this.handles.handlePointerRelease);
    _this.el.holder.removeEventListener("contextmenu", _this.handles.handlePointerRelease);
    delete _this.handles.handlePointerRelease;
  }
};


FWSlider.prototype.gotoCallback = function() {
  var _this = this,
      updatePosition = function() {
        _this.el.holder.style.transform = 'translate3d(-' + _this.index * 100 + '%,0,0)';
      },
      slideChanged;

  _this.distancemoved = 0;
  _this.el.holder.classList.remove(animationClass);

  if (_this.index === 1) {
    _this.index = _this.initialLength + 1;
    updatePosition();
  } else if (_this.index === _this.initialLength + 2) {
    _this.index = 2;
    updatePosition();
  }
  _this.lazyLoadImages(_this.index);


  _this.el.holder.removeEventListener(transitionEvent, _this.handles.animateAndCallback);
  _this.el.holder.removeEventListener("click", _this.preventClickAfterSwipe);
  _this.bindSwipes();

  if(_this.autoplay) {
    _this.startAutoPlay();
  }

  slideChanged = this._actions['slideChanged'];
  if (slideChanged && slideChanged.length) {
    slideChanged.forEach(function(_function) {
      _function.bind(_this)(_this.index);
    })
  }
};

FWSlider.prototype.goto = function goto(destination) {

  var _this = this;
  var oldIndex = _this.index;
  var animateAndCallback = function () {
        _this.el.holder.classList.add(animationClass);
        _this.el.holder.style.transform = 'translate3d(-' + _this.index * 100 + '%,0,0)';
        _this.handles.animateAndCallback = _this.gotoCallback.bind(_this);

        function handleTransitionEvent(){
          _this.handles.animateAndCallback();
          _this.el.holder.removeEventListener(transitionEvent, handleTransitionEvent);
        }

        _this.el.holder.addEventListener(transitionEvent, handleTransitionEvent);
      };

  var slideChanging;

  _this.unbindSwipes();

  if(_this.autoplay) {
    _this.stopAutoPlay();
  }

  if (destination === 'next') {
    _this.index++;
  } else if (destination === 'prev') {
    _this.index--;
  } else if (Number.isInteger(destination)) {
    _this.index = destination + 2;
  }
  _this.updateNavHighlights();

  if (_this.distancemoved !== 0) {
    animateAndCallback();
  } else {
    if (oldIndex !== _this.index) {
      animateAndCallback();
    } else {
      _this.gotoCallback();
    }
  }

  slideChanging = this._actions['slideChanging'];
  if (slideChanging && slideChanging.length) {
    slideChanging.forEach(function(_function) {
      _function.bind(_this)({from:oldIndex, to:_this.index});
    })
  }
};


// define type of transition to listen
function whichTransitionEvent() {
  var t,
      el = document.createElement("div"),
      transitions = {
        "transition": "transitionend",
        "OTransition": "oTransitionEnd",
        "MozTransition": "transitionend",
        "WebkitTransition": "webkitTransitionEnd"
      };

  for (t in transitions) {
    if (el.style[t] !== undefined) {
      return transitions[t];
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules-es5/commons/lib/lib-full-width-slider.js